import { View } from 'react-native';
import createAnimatedComponent from '../../createAnimatedComponent';
const AnimatedView = createAnimatedComponent(View);
export default AnimatedView;
